import { useContext } from 'react';
import { createContext } from 'react';

import { RelatedProductsProps } from '../@types/RelatedProductsProps';

export const RelatedProductsContext = createContext<RelatedProductsProps>({} as RelatedProductsProps);

RelatedProductsContext.displayName = 'RelatedProducts';

const RelatedProductsProvider = (props: RelatedProductsProps) => (
	<RelatedProductsContext.Provider value={props}>{props.children}</RelatedProductsContext.Provider>
);

export const useRelatedProducts = () => {
	const context = useContext(RelatedProductsContext);

	return context;
};

export default RelatedProductsProvider;
